import { Flex, Skeleton } from "antd";

export function SkeletonCoinSelector() {
  return (
    <Flex gap="small" style={{ width: "100%", maxWidth: "100%", flexWrap: "wrap" }}>
      <Skeleton.Button
        active
        size="default"
        shape="default"
        style={{ width: "min(130px, 42vw)" }}
      />
      <Skeleton.Input
        active
        size="default"
        style={{ width: "min(240px, 56vw)", maxWidth: "100%" }}
      />
    </Flex>
  );
}

export function SkeletonTimeIntervalSelector() {
  return (
    <Flex gap="small" style={{ width: "100%", maxWidth: "100%", flexWrap: "wrap" }}>
      {Array.from({ length: 5 }).map((_, idx) => (
        <Skeleton.Button
          key={idx}
          active
          size="small"
          shape="default"
          style={{ width: "min(40px, 11vw)" }}
        />
      ))}
    </Flex>
  );
}

export function SkeletonUsersSelector() {
  return (
    <Flex gap="middle" style={{ width: "100%", maxWidth: "100%" }}>
      <Skeleton.Button
        active
        size="default"
        shape="default"
        style={{ width: "min(200px, 100%)", maxWidth: "100%" }}
      />
    </Flex>
  );
}

export function SkeletonTable({
  columnsCount,
  rowsCount,
}: {
  columnsCount: number;
  rowsCount: number;
}) {
  const columns = [...Array(columnsCount).keys()];
  const rows = [...Array(rowsCount).keys()];

  return (
    <Flex justify="space-around" vertical style={{ width: "100%", maxWidth: "100%" }}>
      <Flex key={"flexHeader"} gap="small" vertical={false} style={{ width: "100%" }}>
        {columns.map((cc) => (
          <div key={cc} style={{ flex: "1 1 0", minWidth: 0 }}>
            <Skeleton.Button active size="large" shape="default" block />
          </div>
        ))}
      </Flex>
      <Flex key="flexRows" vertical style={{ width: "100%", maxWidth: "100%" }}>
        {rows.map((r) => (
          <Flex
            style={{ marginTop: "1em", width: "100%" }}
            key={r}
            gap="small"
            vertical={false}
          >
            {columns.map((c) => (
              <div key={r + c} style={{ flex: "1 1 0", minWidth: 0 }}>
                <Skeleton.Button active size="default" shape="default" block />
              </div>
            ))}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}

export function SkeletonChart({ w }: { w: number }) {
  return (
    <>
      <Skeleton.Node
        active
        style={{ width: `min(100%, ${w}px)`, maxWidth: "100%", height: 450 }}
      />
    </>
  );
}

export function SkeletonChartModal() {
  return (
    <Skeleton.Node
      active
      style={{ width: "100%", height: 350, marginTop: 10 }}
    />
  );
}

export function SkeletonHeader() {
  return (
    <>
      <Skeleton.Input active size="large" block style={{ width: "min(200px, 100%)" }} />
    </>
  );
}

export function SkeletonFormText({ w }: { w: number }) {
  return (
    <Flex gap="middle" style={{ width: "100%", maxWidth: "100%", flexWrap: "wrap" }}>
      <Skeleton.Input
        active
        size="small"
        style={{ width: `min(${w}px, 100%)`, maxWidth: "100%" }}
      />
      <Skeleton.Input
        active
        size="small"
        style={{ width: "min(220px, 100%)", maxWidth: "100%" }}
      />
    </Flex>
  );
}

export function SkeletonPublicName({ w }: { w: number }) {
  return (
    <Flex gap="middle" style={{ width: "100%", maxWidth: "100%", flexWrap: "wrap" }}>
      <Skeleton.Input
        active
        size="small"
        style={{ width: `min(${w}px, 100%)`, maxWidth: "100%" }}
      />
      <Skeleton.Input
        active
        size="small"
        style={{ width: "min(220px, 100%)", maxWidth: "100%" }}
      />
      <Skeleton.Button active shape="square" size="small" />
    </Flex>
  );
}

export function SkeletonButton() {
  return (
    <>
      <Skeleton.Button
        active
        size="default"
        shape="square"
        style={{ width: "min(200px, 100%)", maxWidth: "100%" }}
      />
    </>
  );
}

export function SkeletonFormInput() {
  return (
    <>
      <Skeleton.Input active size="small" block={true} />
    </>
  );
}

export function SkeletonSampleField() {
  return (
    <>
      <Skeleton.Node active style={{ width: "100%", height: 150 }} />
    </>
  );
}

export function SkeletonPoolLuck() {
  return (
    <Flex
      gap="middle"
      vertical={false}
      justify="center"
      style={{ width: "100%", maxWidth: "100%", flexWrap: "wrap" }}
    >
      <Skeleton.Button active style={{ width: "min(130px, 45%)", height: 89 }} />
      <Skeleton.Button active style={{ width: "min(130px, 45%)", height: 89 }} />
      <Skeleton.Button active style={{ width: "min(130px, 45%)", height: 89 }} />
      <Skeleton.Button active style={{ width: "min(130px, 45%)", height: 89 }} />
      <Skeleton.Button active style={{ width: "min(130px, 45%)", height: 89 }} />
    </Flex>
  );
}

export function SkeletonPoolStats() {
  return (
    <Flex
      gap="middle"
      vertical={false}
      justify="flex-start"
      style={{ width: "100%", maxWidth: "100%", flexWrap: "wrap" }}
    >
      <Skeleton.Button active style={{ width: "min(65px, 22%)", height: 22 }} />
      <Skeleton.Button active style={{ width: "min(65px, 22%)", height: 22 }} />
      <Skeleton.Button active style={{ width: "min(65px, 22%)", height: 22 }} />
      <Skeleton.Button active style={{ width: "min(65px, 22%)", height: 22 }} />
    </Flex>
  );
}
